export const CNCK = {
    wizard: {
        insuranceCoverage: {
            title: 'SAFE Keeping Plan',
            noInsuranceSelected: 'No SAFE Keeping Plan selected',
        },
        bookingConfirmation: {
            idVerifyText:
        'Thank you for your booking you can verify your ID below by clicking the button. Please note you will not receive a copy of your lease until your ID has been verified.',
        },
    },
    map: {
        bigger: 'Larger',
        booking_card: {
            different_unit: '',
        },
    },
};
